import React from 'react';

import styles from './DoughnutCard.module.scss';
import StatisticsCard from '../../../../Shared/StatisticsCard/StatisticsCard';

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    LineElement,
    Title,
    Tooltip,
    Legend,
    PointElement,
    RadialLinearScale,
    Filler,
    ArcElement
} from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    LineElement,
    PointElement,
    RadialLinearScale,
    Title,
    Tooltip,
    Legend,
    Filler,
    ArcElement
);

const options = {
    elements: {
        point: {
            radius: 5,
        },
        line: {
            borderWidth: 1,
            borderColor: "#00000033",
            backgroundColor: "#68DB5A44",
        }
    }
};

function DoughnutCard(props: DoughnutCardProps) {
    return (
        <StatisticsCard
            title={props.title}
        >
            <div className={styles.cardcontent}>
                { props.overlay != undefined ? <div className={styles.overlay}>{props.overlay}</div> : null }
                { props.data != undefined && props.data.datasets.length > 0 ?
                    <Doughnut
                        options={{
                            ...options,
                            ...props.options
                        }}
                        data={props.data}
                        redraw={true}
                    ></Doughnut>
                : null }
            </div>
        </StatisticsCard>
    );
}

class DoughnutCardProps {
    title!: string;
    data!: any;
    options?: any;
    overlay?: any;
}

export default DoughnutCard;